<template>
  <div class="lease-wrapper">
    <div class="lease">
      <p v-for="(paragraph, index) in leaseParagraphs" :key="`${index}-${paragraph.text}`"
        :class="{ 'lease__emphasis': paragraph.isEmphasis }">
        <strong v-if="paragraph.label">{{ paragraph.label }}</strong>{{ paragraph.body }}
      </p>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import { LANGUAGE } from '@/common/constants';
import { getRentalTerms } from '@/api/common';

export default {
  name: 'Lease',

  data() {
    return {
      leaseHtml: ''
    };
  },

  computed: {
    isId() {
      return i18n.locale === LANGUAGE.id;
    },

    // 根据当前语言决定请求哪个配置
    configKey() {
      return this.isId ? 'rental-terms-id' : 'rental-terms-en';
    },
    leaseParagraphs() {
      const html = String(this.leaseHtml || '');
      if (!html) return [];
      const blocks = html.match(/<(p|h[1-6])\b[^>]*>[\s\S]*?<\/\s*\1>/gi) || [];
      const source = blocks.length ? blocks : [html];
      return source
        .flatMap(block => {
          const attrs = (block.match(/^<(?:p|h[1-6])\b([^>]*)>/i) || [])[1] || '';
          const raw = block
            .replace(/^<(?:p|h[1-6])\b[^>]*>/i, '')
            .replace(/<\/\s*(?:p|h[1-6])>$/i, '')
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<[^>]+>/g, '')
            .replace(/&nbsp;|&#160;/gi, ' ')
            .replace(/&amp;/gi, '&')
            .replace(/&quot;/gi, '"')
            .replace(/&#39;|&apos;/gi, "'");
          return raw.split(/\n+/).map(text => text.trim()).filter(Boolean).map(text => ({
            text,
            isEmphasis: /^(part|section|bagian)\s/i.test(text) || /\?$/.test(text)
              || /font-bold|font-semibold|class=["'][^"']*fb/i.test(attrs),
          }));
        })
        .map(paragraph => {
          const match = paragraph.isEmphasis ? null : paragraph.text.match(/^(.{1,72}:)(\s*)(.*)$/);
          return {
            ...paragraph,
            label: match ? match[1] : '',
            body: match ? `${match[2]}${match[3]}` : paragraph.text,
          };
        });
    }
  },

  watch: {
    // 当语言切换时重新获取
    configKey() {
      this.fetchLeaseContent();
    }
  },

  created() {
    this.fetchLeaseContent();
  },

  methods: {
    async fetchLeaseContent() {
      try {
        const res = await getRentalTerms({
          keys: this.configKey
        });

        if (res?.code === 'Success' && Array.isArray(res.data) && res.data.length > 0) {
          // 精准匹配 configKey
          const item = res.data.find(i => i.configKey === this.configKey);
          this.leaseHtml = item ? String(item.configValue || '') : '';
        } else {
          this.leaseHtml = '';
        }
      } catch (error) {
        console.error('获取租机说明失败:', error);
        this.leaseHtml = '';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.lease-wrapper {
  margin: -16px;
  padding: 16px 16px 24px;
  background: #F4F8FF;

  .lease {
    font-size: 26px;
    color: var(--text-color-gray);
    line-height: 38px;
    text-align: left;
    font-weight: 400;

    p {
      margin: 0;
      padding-bottom: 16px;
    }

    &__emphasis {
      padding-top: 28px;
      padding-bottom: 8px;
      font-weight: 400;
    }

    p:first-child {
      padding-top: 0;
    }

    strong {
      font-weight: 700;
    }
  }
}
</style>
